import { BookingInfoProperties, BookingPassengerInfoProperties, PassengerCreationResponse } from "../Models/BookingPassengerTicketIssuanceProperties";
import { PostAncillaryGetProperties } from "../Models/PostModificationProperties";
import { VoidTicketProperties } from "../Models/TicketIssuanceProperties";
import { PostTicketingModificationService } from "../Services/PostTicketingModification.service";

export class EmiratesEnumsForExchangedDivide {
  none = 0;
  exchangedVoidTicket = 1;
  initialVoidTicket = 2;
  exchangedRefundTicket = 3;
  initialRefundTicket = 4;
  exchangedAddPostANCITicket = 5;
  initialAddPostANCITicket = 6;
  exchangedIssueSSRTicket = 7;
  initialIssueSSRTicket = 8;
  exchanged = 9;
  initial = 10;
  exchangedtktrefundpopOpen = 11;
  initialtktrefundpopOpen = 12;
  exchangedtktvoidpopOpen = 13;
  initialtktvoidpopOpen = 14;
  exchangedAnciAvail = 15;
  initialAnciAvail = 16;
}
export class EmiratesModificationFunctions {
  constructor(private postservice: PostTicketingModificationService) {

  }
  voidlist: BookingPassengerInfoProperties[] = [];
  bookingpassenger: BookingPassengerInfoProperties[] = [];
  emiratesEnumsForExchangedDivide = new EmiratesEnumsForExchangedDivide();
  bookingRefundInfo = new BookingInfoProperties();
  pscreation = new PassengerCreationResponse();
  async VoidTicketExchanged(voidPassengerInfo: BookingPassengerInfoProperties[], type: number, bookingInfo: BookingInfoProperties): Promise<PassengerCreationResponse> {


    let voidprop = new VoidTicketProperties();
    let voidcount = 0;
    for (let j = 0; j < voidPassengerInfo.length; j++) {
      if (voidPassengerInfo[j].isVoid) {
        voidcount++;
      }

    }

    if (voidcount != voidPassengerInfo.length) {
      for (let j = 0; j < voidPassengerInfo.length; j++) {
        if (voidPassengerInfo[j].isVoid) {
          if (voidPassengerInfo[j].passengerType == 1) {
            for (let k = 0; k < voidPassengerInfo.length; k++) {
              if (voidPassengerInfo[j].firstName == voidPassengerInfo[k].associatedAdult) {
                if (!voidPassengerInfo[k].isVoid) {
                  voidPassengerInfo[k].isVoid = true;
                  break;
                }
              }
            }
          }
          if (voidPassengerInfo[j].passengerType == 3) {
            for (let k = 0; k < voidPassengerInfo.length; k++) {
              if (voidPassengerInfo[j].associatedAdult == voidPassengerInfo[k].firstName) {
                if (!voidPassengerInfo[k].isVoid) {
                  voidPassengerInfo[k].isVoid = true;
                  break;
                }
              }
            }
          }
        }
      }
      for (let j = 0; j < voidPassengerInfo.length; j++) {
        if (voidPassengerInfo[j].isVoid) {
          if (voidPassengerInfo[j].passengerType != 3) {
            voidprop.Tickets.push(voidPassengerInfo[j].ticketNo);
          }
        }
      }
    }
    else {
      for (let j = 0; j < voidPassengerInfo.length; j++) {
        if (voidPassengerInfo[j].isVoid) {
          voidprop.Tickets.push(voidPassengerInfo[j].ticketNo);
        }
      }
    }




    //select Tickets needs to be voided.
    voidprop.bookingobj = new BookingInfoProperties();
    voidprop.bookingobj = bookingInfo;
    voidprop.bookingobj.parentHierarchy = localStorage.getItem("ParentHierarchy");
    if (type == this.emiratesEnumsForExchangedDivide.exchanged) {
      return new Promise<PassengerCreationResponse>((resolve, reject) => {
        this.postservice.ExchangeVoidReq(voidprop).subscribe((data: PassengerCreationResponse) => {
          resolve(data);
        }, error => {
          reject(error);
        });
      });
    }
    else if (type == this.emiratesEnumsForExchangedDivide.initial) {
      return new Promise<PassengerCreationResponse>((resolve, reject) => {
        this.postservice.InitialVoidReq(voidprop).subscribe((data: PassengerCreationResponse) => {
          resolve(data);
        }, error => {
          reject(error);
        });
      });
    }

  }


  async GetAnciAvailREQ(type: number, bookingInfo: BookingInfoProperties): Promise<PostAncillaryGetProperties> {
    let postAncillary = new PostAncillaryGetProperties();
    postAncillary.bookingObj = bookingInfo;
  
    if (type == this.emiratesEnumsForExchangedDivide.exchanged) {
      this.bookingpassenger = [];
      for (let p = 0; p < bookingInfo.exchangebookingPassengerInfoProperties.length; p++) {
        if (!bookingInfo.exchangebookingPassengerInfoProperties[p].isRefund && !bookingInfo.exchangebookingPassengerInfoProperties[p].isVoid) {
          this.bookingpassenger.push(bookingInfo.exchangebookingPassengerInfoProperties[p]);
        }
      }
      postAncillary.bookingObj.bookingPassengerInfoProperties = [];
      postAncillary.bookingObj.bookingPassengerInfoProperties = this.bookingpassenger;
      return new Promise<PostAncillaryGetProperties>((resolve, reject) => {
        this.postservice.ExchangePostANCIAvailiabilityEmirates(postAncillary).subscribe((data: PostAncillaryGetProperties) => {
          resolve(data);
        }, error => {
          reject(error);
        });
      });
    }
    else if (type == this.emiratesEnumsForExchangedDivide.initial) {
      this.bookingpassenger = [];
      for (let p = 0; p < bookingInfo.bookingPassengerInfoProperties.length; p++) {
        if (!bookingInfo.bookingPassengerInfoProperties[p].isRefund && !bookingInfo.bookingPassengerInfoProperties[p].isVoid && bookingInfo.bookingPassengerInfoProperties[p].bookingStatus != "Exchanged") {
          this.bookingpassenger.push(bookingInfo.bookingPassengerInfoProperties[p]);
        }
      }
      postAncillary.bookingObj.bookingPassengerInfoProperties = this.bookingpassenger;
      return new Promise<PostAncillaryGetProperties>((resolve, reject) => {
        this.postservice.InitialPostANCIAvailiabilityEmirates(postAncillary).subscribe((data: PostAncillaryGetProperties) => {
          resolve(data);
        }, error => {
          reject(error);
        });
      });
    }
  }

  voidpopOpen(bookObj: BookingInfoProperties, type: number): any {
    this.voidlist=[]
    if (type == this.emiratesEnumsForExchangedDivide.exchanged) {
      for (let j = 0; j < bookObj.exchangebookingPassengerInfoProperties.length; j++) {
        if (!bookObj.exchangebookingPassengerInfoProperties[j].isVoid) {
          this.voidlist.push(bookObj.exchangebookingPassengerInfoProperties[j]);
        }
      }
    }
    else if (type == this.emiratesEnumsForExchangedDivide.initial) {
      for (let j = 0; j < bookObj.bookingPassengerInfoProperties.length; j++) {
        if (!bookObj.bookingPassengerInfoProperties[j].isVoid && bookObj.bookingPassengerInfoProperties[j].bookingStatus != "Exchanged") {
          this.voidlist.push(bookObj.bookingPassengerInfoProperties[j]);
        }
      }
    }

    return this.voidlist;
  }

  refundpopOpen(bookObj: BookingInfoProperties, type: number): any {
    this.bookingRefundInfo = JSON.parse(JSON.stringify(bookObj));
    this.bookingRefundInfo.bookingPassengerInfoProperties = [];
    if (type == this.emiratesEnumsForExchangedDivide.exchanged) {
      for (let j = 0; j < bookObj.exchangebookingPassengerInfoProperties.length; j++) {
        if (!bookObj.exchangebookingPassengerInfoProperties[j].isRefund) {
          this.bookingRefundInfo.bookingPassengerInfoProperties.push(bookObj.exchangebookingPassengerInfoProperties[j]);
        }
      }
    }
    else if (type == this.emiratesEnumsForExchangedDivide.initial) {
      for (let j = 0; j < bookObj.bookingPassengerInfoProperties.length; j++) {
        if (!bookObj.bookingPassengerInfoProperties[j].isRefund && bookObj.bookingPassengerInfoProperties[j].bookingStatus != "Exchanged") {
          this.bookingRefundInfo.bookingPassengerInfoProperties.push(bookObj.bookingPassengerInfoProperties[j]);
        }
      }
    }

    return this.bookingRefundInfo;
  }
}

